// extracted by mini-css-extract-plugin
export default {"input-container":"TextInput_input-container__dLAoq","icon":"TextInput_icon__oo03a"};